import React, { useState, useEffect } from "react";
import { Box, Alert, AlertIcon } from "@chakra-ui/core";
import DasboardHeader from "../components/dashboard/DashboardHeader";
import DashboardLeadingSection from "../components/dashboard/DashboardLeadingSection";
import DashboardBodyHeader from "../components/dashboard/DashboardBodyHeader";
import DashboardBodyMain from "../components/dashboard/DashboardBodyMain";

import { Spinner, Flex } from "@chakra-ui/core";
import { useQuery } from "react-apollo";

import { GET_MERCHANT_DETAILS } from "../graphql/queries";
import Footer from "../components/common/Footer";

function Dashboard() {
  const [currentSection, setCurrentSection] = React.useState("orders");
  const [loading, setLoading] = useState(true);
  const [merchantDetails, setMerchantDetails] = useState({});
  const [err, setErr] = useState();

  const { error, data, refetch } = useQuery(GET_MERCHANT_DETAILS, {
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (data) {
      setMerchantDetails(data.getMerchantDetails);
      setLoading(false);
    }

    if (error) {
      setErr("Error loading app");
      setLoading(false);
    }
  }, [data, error]);

  if (error) {
    throw error;
  }

  return (
    <>
      {loading && (
        <Flex alignItems="center" height="50vh" justifyContent="center">
          <Spinner />
        </Flex>
      )}

      {err && (
        <Box
          height="100vh"
          alignItems="center"
          justifyContent="center"
          display="flex"
          width="100%"
        >
          <Alert status="error" justifyContent="center" minWidth="40%">
            <AlertIcon />
            {err}
          </Alert>
        </Box>
      )}

      {Object.keys(merchantDetails).length > 0 && (
        <>
          <DasboardHeader
            {...{ currentSection, setCurrentSection, merchantDetails }}
          />
          <DashboardLeadingSection
            businessName={merchantDetails.businessName}
            balance={merchantDetails.balance}
            stripeAccountId={merchantDetails.stripeAccountId}
            transactions={merchantDetails.transactions}
            refetch={refetch}
          />
          <DashboardBodyHeader {...{ currentSection }} />
          <DashboardBodyMain
            {...{ currentSection }}
            customers={merchantDetails.customers}
            transactions={merchantDetails.transactions}
            payouts={merchantDetails.payouts}
            refetch={refetch}
          />
          <Footer />
        </>
      )}
      {/* <SignupAndLogin isOpen={showLoginForm} intend="login" /> */}
    </>
  );
}

export default Dashboard;
